import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import Button from '../components/Button';
import emailVerifiedImg from '../assets/email_verified.svg';
import useAuthStore from '../stores/authStore';

const VerifiedPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const clearJustVerified = useAuthStore((state) => state.clearJustVerified);
  const justVerified = useAuthStore((state) => state.justVerified);
  
  useEffect(() => {
    // If user didn't just complete verification, redirect to homepage
    if (!justVerified) {
      navigate('/', { replace: true });
      return;
    }
    
  }, [clearJustVerified, justVerified, navigate]);
  
  const goToHomepage = () => {
    clearJustVerified();
    navigate('/');
  };

  return (
    <div className="container py-8 flex items-center">
      <div className="max-w-[406px] mx-auto">
        <div className="self-stretch inline-flex flex-col justify-start items-center gap-9">
          <div className="w-[280.62px] h-[182.99px] relative">
            <img 
              src={emailVerifiedImg} 
              alt="Email verified" 
              className="w-full h-full"
            />
          </div>
          <div className="self-stretch flex flex-col justify-start items-center gap-6">
            <div className="w-[216px] flex flex-col justify-start items-center gap-2">
              <div className="self-stretch text-center justify-center text-[#111111] text-lg font-bold">{t('auth.signup.success.title')}</div>
            </div>
            <div className="self-stretch text-center justify-center text-[#aaaaaa] text-sm font-normal tracking-tight">{t('auth.signup.success.description')}</div>
            <Button 
              variant="default" 
              size="xl" 
              className="w-full"
              onClick={goToHomepage}
            >
              <span className="text-lg font-bold">
                {t('auth.signup.success.home_button')}
              </span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifiedPage; 